import React, { Component } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import { AppCard, PageLayout } from "../../components/ui";
import { createTabHeaderTemplate } from "../../components/ui/tabHeaderTemplate";
import { CreditCard } from "lucide-react";
import IssuingClients from "./IssuingClients";
import ReportingMainComponent from "./Reporting";

interface IssuingComponentProps {
    merchantId: number | null;
    isDashboard: boolean;
}

interface IssuingComponentState {
    activeIndex: number;
}

export default class IssuingComponent extends Component<IssuingComponentProps, IssuingComponentState> {
    constructor(props: IssuingComponentProps) {
        super(props);
        this.state = { activeIndex: 0 };
    }

    render() {
        return (
            <PageLayout heading="Issuing" icon={CreditCard}>
                <AppCard>
                    <AppCard.Body className="!p-0">
                        <TabView
                            activeIndex={this.state.activeIndex}
                            onTabChange={(e) => this.setState({ activeIndex: e.index })}
                        >
                            <TabPanel header="Clients" headerTemplate={createTabHeaderTemplate(this.state.activeIndex)}>
                                <IssuingClients />
                            </TabPanel>
                            <TabPanel header="Reporting" headerTemplate={createTabHeaderTemplate(this.state.activeIndex)}>
                                <ReportingMainComponent merchantId={null} isDashboard={false} />
                            </TabPanel>
                        </TabView>
                    </AppCard.Body>
                </AppCard>
            </PageLayout>
        );
    }
}
